import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from "react-router-dom";
import {getRequest, getRequests, payRequest, storeRequest} from "../api/RequestsAPI";
import { showError, showSuccess } from "../../../utils/toastHelper";

// Import Icons
import {
    HiOutlineLocationMarker,
    HiOutlineQrcode
} from "react-icons/hi";
import { BsCalendar4Week, BsBuilding } from "react-icons/bs";
import {TbCoin, TbStatusChange, TbPhone, TbArrowBadgeLeft, TbCreditCardPay} from "react-icons/tb";
import { MdOutlinePayment, MdVerified, MdOutlineCancel } from "react-icons/md";
import { CiMoneyBill, CiViewList } from "react-icons/ci";



import Header from "../../../layouts/Header";
import Loading from "../../../layouts/Loading";
import {IoCheckmarkSharp, IoWalletSharp} from "react-icons/io5";
import {GiCash} from "react-icons/gi";

import {toast} from "react-toastify";
import {RiShieldUserFill} from "react-icons/ri";
import PaymentHistory from "./PaymentHistory"; // فرض می‌کنیم این کامپوننت وجود دارد

const currencyFormat = Intl.NumberFormat('en-US');

function RequestDetails() {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [request, setRequest] = useState(null);
    const [payType, setPayType] = React.useState(0);
    const [payableAmount, setPayableAmount] = React.useState(0);
    const [checked, setChecked] = useState(false);

    const config = window.APP_CONFIG;


    useEffect(() => {

        const search = window.location.search;
        const query = new URLSearchParams(search);
        const message = query.get('m');

        if (message) {
            const success = query.get('s');
            success === '1' ? showSuccess(message) : showError(message);
        }

        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await getRequest(id);
                setRequest(result.data);
                if (result.data.service_payable_amount > 0) {
                    setPayableAmount(result.data.service_payable_amount + result.data.transportation_amount - result.data.payed_amount);
                }
                else {
                    setPayableAmount(result.data.prepayment_amount + result.data.transportation_amount - result.data.payed_amount);
                }

            } catch (err) {
                showError("خطا در دریافت اطلاعات درخواست.");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    // محاسبه مقادیر مشتق شده با useMemo برای بهینه‌سازی
/*    const { totalPrice, discount } = useMemo(() => {
        const total = request?.details?.reduce((sum, detail) => sum + parseInt(detail.service_price) * detail.count, 0) || 0;
        const disc = total - (request?.pay_amount || 0);
        return { totalPrice: total, discount: disc };
    }, [request]);*/


    const onPayClick = async () =>{
        try {
            setLoading(true);
            const request = {
                service_request_id : id,
                pay_type: payType,
                onlyPrepayment : checked ? 1 : 0,
                bank_unique_code: 'payping',
            }
            const result = await payRequest(request);
            toast.success(result.message);

            if (payType === 13) {
                setTimeout(() => {
                        window.location.assign(result.data.paymentURL + '&external=true');
                }, 1000)
                return true;
            }

            setTimeout(() => {
                window.location.reload()
            }, 1000)

        } catch (err) {
            showError(err)
            setLoading(false);
        } finally {

        }
    }

    if (loading) {
        return <Loading />;
    }

    if (!request) {
        return <div className="loading-container">اطلاعاتی برای نمایش وجود ندارد.</div>;
    }

    return (
        <>
            <Header title="  اطلاعات درخواست" hasBack={true}/>

            <div className="modal fade bottom-sheet " id="paymentTypeModal" tabIndex="-1"
                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-bottom mobile-size-option">
                    <div className="modal-content">
                        <div className="modal-header rtl">

                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                انتخاب روش پرداخت
                            </h1>

                        </div>
                        <div className="modal-body ">
                            {
                                config.service_app_settings.online_payment > 0 &&
                                <div className="row border-bottom pb-2"
                                     onClick={() => {
                                         setPayType(13)
                                     }}
                                >
                                    <div className="col-2 mt-3">
                                        <TbCreditCardPay
                                            className={payType === 13 ? 'text-big-4 text-third-color' : 'text-big-3'}/>
                                    </div>
                                    <div className="col-8">
                                        <strong
                                            className={payType === 13 ? 'text-big-2 text-third-color' : 'text-big-2 '}>پرداخت
                                            آنلاین</strong>
                                        <p className='mt-2 text-small-1'>
                                            پرداخت با کلیه کارتهای عضو شتاب
                                        </p>
                                    </div>
                                    <div className={payType === 13 ? 'col-2' : 'col-2 d-none'}>
                                        <IoCheckmarkSharp className='text-big-4 text-third-color'/>
                                    </div>
                                </div>
                            }
                            {
                                config.service_app_settings.cash_payment > 0 && request?.last_status?.id > 0 &&
                                <div className="row border-bottom py-2"
                                     onClick={() => {

                                         setPayType(12)
                                     }}
                                >
                                    <div className="col-2 mt-3">
                                        <GiCash
                                            className={payType === 12 ? 'text-big-4 text-third-color' : 'text-big-3'}/>
                                    </div>
                                    <div className="col-8 pt-3">
                                        <strong
                                            className={payType === 12 ? 'text-big-2 text-third-color' : 'text-big-2 '}>پرداخت
                                            نقدی</strong>
                                        <p className='mt-2 text-small-1'>
                                            پرداخت مبلغ به صورت نقدی به

                                            {" "}
                                            {
                                                config.service_app_settings.servitor_title
                                            }
                                        </p>
                                    </div>
                                    <div className={payType === 12 ? 'col-2' : 'col-2 d-none'}>
                                        <IoCheckmarkSharp className='text-big-4 text-third-color'/>
                                    </div>
                                </div>
                            }
                            {
                                config.service_app_settings.wallet_payment > 0 &&
                                <div className="row border-bottom py-2"
                                     onClick={() => {
                                         if (request?.user?.wallet_inventory < payableAmount) {
                                             showError('موجودی کیف پول برای  پرداخت این مبلغ کافی نیست')
                                             return false;
                                         }
                                         setPayType(14)
                                     }}
                                >
                                    <div className="col-2 mt-3">
                                        <IoWalletSharp
                                            className={payType === 14 ? 'text-big-4 text-third-color' : 'text-big-3'}/>
                                    </div>
                                    <div className="col-8 pt-3">
                                        <strong
                                            className={payType === 14 ? 'text-big-2 text-third-color' : 'text-big-2 '}>پرداخت
                                            کیف پول
                                            &nbsp;
                                            {
                                                request?.user?.wallet_inventory < payableAmount ?
                                                    <span className='text-danger text-small-3 mx-2'>ناکافی</span>
                                                    :
                                                    <span className='text-success text-small-3 mx-2'>کافی</span>
                                            }

                                        </strong>
                                        <p className='mt-2 text-small-1'>
                                            موجودی کیف پول شما:
                                            &nbsp;
                                            <strong>
                                                {currencyFormat.format(request?.user?.wallet_inventory)}

                                            </strong>
                                            &nbsp;
                                            {config.currency}
                                            &nbsp;


                                        </p>
                                    </div>
                                    <div className={payType === 14 ? 'col-2' : 'col-2 d-none'}>
                                        <IoCheckmarkSharp className='text-big-4 text-third-color'/>
                                    </div>
                                </div>
                            }


                        </div>
                        <div className="modal-footer ">
                            <button type="button" className="btn btn-secondary text-small-1"
                                    data-bs-dismiss="modal"

                            >
                                انصراف
                            </button>
                            <button type="button"
                                    className="btn text-white bg-primary-color w-75 text-small-1"
                                    onClick={onPayClick}
                                    data-bs-dismiss="modal"
                                    disabled={payType === 0}
                            >
                                پرداخت و ثبت درخواست
                            </button>


                        </div>
                    </div>
                </div>
            </div>

            <div className="request-details-page pb-5 mb-5 mt-5">
                <div className="container">
                    {/* Card 1: Summary Card */}
                    <div className="summary-card">
                        {request?.last_status?.id > 0 &&
                            <div className="summary-item">
                                <span className="label">شماره پیگیری</span>
                                <div className="value">
                                    <HiOutlineQrcode/>
                                    <span>{request.tracking_code}</span>
                                </div>
                            </div>
                        }
                        <div className="summary-item">
                            <span className="label">وضعیت فعلی</span>
                            <div className='value text-small-2 status-badge bg-secondary-subtle'
                                 style={{color: request?.last_status?.color}}>
                                <TbStatusChange/>
                                <span>{request?.last_status?.title}</span>
                            </div>
                            {
                                request?.last_status?.id < 1 &&
                                <div className='mt-3 alert alert-danger text-justify'>
                                    برای قطعی شدن درخواست لطفا نسبت به پرداخت مبلغ درخواست اقدام کنید.
                                </div>
                            }
                        </div>
                    </div>


                    {request.servitor &&
                        <div className="row">

                            <div className="col-12">
                                <div className="card  p-2 mb-3 w-100 info-card"
                                >
                                    <div>
                                        <h3><RiShieldUserFill/>
                                            مشخصات
                                            {" "}
                                            {
                                                config.service_app_settings.servitor_title
                                            }
                                        </h3>
                                    </div>
                                    <div className='text-center'>
                                        <img
                                            src={request.servitor.avatar}
                                            alt={`${request.servitor.first_name} ${request.servitor.last_name}`}
                                            className="rounded-circle me-3"
                                            style={{
                                                width: '64px',
                                                height: '64px',
                                                objectFit: 'cover',
                                                background: '#eee'
                                            }}
                                        />
                                        <div>
                                            <div
                                                className="fw-bold mb-1">{request.servitor.first_name} {request.servitor.last_name}</div>
                                            <a href={`tel:${request.servitor.username}`}
                                               className="text-primary text-decoration-none fw-semibold">
                                                {request.servitor.username}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    }
                    <div className="row">
                        <div className="col-12">
                            <div className="alert alert-warning text-justify text-small-1">
                                <p dangerouslySetInnerHTML={{__html: config.service_app_settings.request_page_text}}></p>

                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        {/* Column 1: Request Info */}
                        <div className="col-lg-7">
                            <div className="info-card">
                                <h3><CiViewList/> اطلاعات درخواست</h3>
                                <div className="info-item">
                                    <BsCalendar4Week className="icon"/>
                                    <div className="details">
                                        <span className="title">تاریخ و زمان مراجعه</span>
                                        {
                                            request.is_urgent > 0 ?
                                                <span className='text-danger fw-bold'>
                                                    در اسرع وقت (فوری)
                                                </span>
                                                :
                                                <span
                                                    className="value">{request.doing_date} - {request.doing_time}</span>
                                        }
                                    </div>
                                </div>
                                <div className="info-item">
                                    <HiOutlineLocationMarker className="icon"/>
                                    <div className="details">
                                        <span className="title">آدرس</span>
                                        <span className="value">
                                            <b>
                                                {request?.address?.title}
                                                :
                                            </b>
                                            {request?.address?.address}</span>
                                        <a target='_blank'
                                           href={`https://www.google.com/maps/dir/?api=1&destination=${request?.address?.lat},${request?.address?.lng}`}
                                           className="map-link">مشاهده روی نقشه</a>
                                    </div>
                                </div>
                                <div className="info-item">
                                    <BsBuilding className="icon"/>
                                    <div className="details">
                                        <span className="title">اطلاعات مرکز خدماتی</span>
                                        <span className="value">{request?.company?.title}</span>
                                    </div>
                                </div>
                                <div className="info-item">
                                    <TbPhone className="icon"/>
                                    <div className="details w-100">
                                        <span className="title">تلفن پشتیبانی</span>
                                        <div className="text-start w-100">

                                            <a href={"tel:" + request?.company?.support_phone}>
                                                {request?.company?.support_phone}
                                            </a>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* Column 2: Financial Info */}
                        <div className="col-lg-5">
                            <div className="finance-card">
                                <h3><MdOutlinePayment/> جزئیات مالی</h3>
                                <div className="finance-item">
                                    <span className="title"><CiMoneyBill/> هزینه خدمات</span>
                                    {
                                        request.service_payable_amount > 0 ?
                                            <span
                                                className="value">{currencyFormat.format(request.service_payable_amount)}
                                                {" "}
                                                {config.currency}
                                    </span>
                                            :
                                            <span className='fw-bold text-small-2 text-warning'>
                                                هنوز تعیین نشده
                                            </span>
                                    }


                                </div>
                                <div className='w-100 mb-4 fw-bold text-small-2 text-warning text-center '>
                                    «هزینه خدمات پس از بازدید ممکن است تغییر کند»
                                </div>
                                <div className="finance-item">

                                    <span className="title"><CiMoneyBill/>مبلغ بیعانه (پیش پرداخت)</span>
                                    <span
                                        className="value">{currencyFormat.format(request.prepayment_amount)}
                                        {" "}
                                        {config.currency}
                                    </span>

                                </div>
                                <div className="finance-item">

                                    <span className="title"><CiMoneyBill/>هزینه ایاب و ذهاب </span>
                                    <span
                                        className="value">{currencyFormat.format(request.transportation_amount)}
                                        {" "}
                                        {config.currency}
                                    </span>

                                </div>
                                <div className="finance-item text-success">

                                    <span className="title "><CiMoneyBill/>مبلغ پرداخت شده </span>
                                    <span
                                        className="value">{currencyFormat.format(request.payed_amount)}
                                        {" "}
                                        {config.currency}
                                    </span>

                                </div>
                                {
                                    request?.last_status?.id < 1 && request.service_payable_amount > 0 && request.prepayment_amount > 0 &&
                                    <div
                                        className="form-check my-3 deposit-checkbox bg-success-subtle text-small-2 p-2 rounded">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="depositCheck"
                                            checked={checked}
                                            onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setChecked(isChecked);
                                                if (!isChecked) {
                                                    setPayableAmount(request.service_payable_amount + request.transportation_amount - request.payed_amount);
                                                } else {
                                                    setPayableAmount(request.prepayment_amount + request.transportation_amount - request.payed_amount);
                                                }

                                            }}
                                        />
                                        <label className="form-check-label" htmlFor="depositCheck">
                                            می خواهم فقط مبلغ بیعانه را پرداخت کنم!
                                        </label>
                                    </div>
                                }

                                <div className="payable-amount">
                                    <span className="title">
                                        مبلغ قابل پرداخت
                                    </span>
                                    <span
                                        className="value">{currencyFormat.format(payableAmount)}
                                        {" "}
                                        {config.currency}
                                    </span>
                                </div>

                                <PaymentHistory payments={request.payments}/>
                            </div>
                        </div>
                    </div>


                    {/* Card 3: Services List */}
                    <div className="services-card">
                        <h3><TbCoin/> فهرست خدمات</h3>
                        <div className="table-responsive">
                            <table className="table table-hover align-middle">
                                <thead className="table-light">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">عنوان خدمت</th>
                                    <th scope="col">تعداد</th>
                                    <th scope="col" className="text-end">مبلغ ( {config.currency})</th>
                                </tr>
                                </thead>
                                <tbody>
                                {request?.details?.map((detail, index) => (
                                    <tr key={detail.id}>
                                        <td>{index + 1}</td>
                                        <td>{detail.service.title}</td>
                                        <td>{detail.count}</td>
                                        <td className="text-end fw-bold">
                                            {
                                                detail.service_price > 0 ?
                                                    <span
                                                        className="value">{currencyFormat.format(detail.service_price)}


                                    </span>
                                                    :
                                                    <span className='fw-bold text-small-2 '>
                                               تعیین پس از بازدید
                                            </span>
                                            }

                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="file-list-container bg-white">
                        <h5>فایل‌های پیوست</h5>
                        {request.files && request.files.length > 0 ? (
                            <ul className="list-group list-group-flush">
                                {request.files.map((file, index) => (
                                    <li key={index}
                                        className="list-group-item file-item d-flex justify-content-between align-items-center">
                                        <div className="file-info d-flex align-items-center">
                                            <div className="file-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                     viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                     strokeWidth="2"
                                                     strokeLinecap="round" strokeLinejoin="round">
                                                    <path
                                                        d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                                                    <polyline points="13 2 13 9 20 9"></polyline>
                                                </svg>
                                            </div>
                                            <div>
                                                <h6 className="mb-0">{file.title || "فایل بارگزاری شده"}</h6>
                                                {file.description &&
                                                    <p className="mb-0 text-muted small">{file.description}</p>}
                                            </div>
                                        </div>
                                        <a
                                            href={file.path}
                                            download
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-outline-primary btn-sm"
                                        >
                                            دانلود
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="text-muted">هیچ فایلی برای این درخواست پیوست نشده است.</p>
                        )}
                    </div>
                </div>
            </div>

            {
                (payableAmount) > 0 ?
                    <div className="row">

                        <div className="col-12 p-2 fixed-bottom mobile-size-option">
                            <button
                                className="btn btn-success bg-primary-color text-end text-small-1 text-semi-big  w-100 p-2  pe-4 border-0"
                                data-bs-toggle="modal"
                                data-bs-target="#paymentTypeModal"


                            >
                                پرداخت
                                <span className="badge  p-2 float-start">

<TbArrowBadgeLeft className='text-big-3'/>
                    </span>
                            </button>
                        </div>
                    </div>
                    : ''
            }
        </>
    );
}

export default RequestDetails;
